import styled from 'styled-components'
import { NavLink } from 'react-router-dom'
import { breakpoints } from '../../assets/styles/mediaBreakpoints'
import { PillButton } from '../common/stand_alone/pillButton'

/**
 * Navbar component when the screen size is larger than desktop.
 *
 * @param links - an array of objects with the link and title of the navbar items
 * @param buttons - an array of objects with the link and title of the buttons
 */

type Props = {
  links: { to: string; title: string }[]
  buttons?: { title: string; link: string }[]
}

const Navbar = ({ links, buttons }: Props) => {
  return (
    <NavContainer>
      <NavLink to="/">
        <NavLogo src="/images/logos/full-logo.png" alt="Logo" />
      </NavLink>
      <NavItems>
        {links.map((link, index) => (
          <NavItemContainer key={index}>
            <NavItem key={index} to={link.to}>
              {link.title}
            </NavItem>
          </NavItemContainer>
        ))}
      </NavItems>
      {buttons &&
        buttons.map((button, index) => (
          <PillButton key={index} link={button.link} title={button.title} />
        ))}
    </NavContainer>
  )
}

const NavLogo = styled.img`
  height: 64px;
`

const NavContainer = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  padding: 1rem 3rem;
  @media (max-width: ${breakpoints.desktop}px) {
    display: none;
  }
`

const NavItems = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
`
const NavItemContainer = styled.div`
  transition: 0.2s;
  padding: 0.5rem 0;
  border-bottom: 2px solid transparent;
  &:hover {
    border-bottom: 2px solid black;
  }
`

const NavItem = styled(NavLink)`
  text-decoration: none;
  margin: 0 1rem;
  font-weight: bold;
  font-size: 1.2rem;
  color: black;
`

export default Navbar
